// 业务store
import * as utils from '@/utils'

const businessBase = {
  namespaced: true,

  state: {
    listQueryStore: {}, // 查询条件

    componentName: "", // 组件名称
  },

  getters: {
    listQueryStore: state => state.listQueryStore,

    componentName: state => state.componentName,
  },

  mutations: {
    SET_LISTQUERY: (state, val) => {
      if (!utils.isNull(businessBase.state.componentName)) {
        state.listQueryStore[businessBase.state.componentName] = val
      }
    },

    SET_NAME: (state, val) => {
      state.componentName = val
    },
  },

  actions: {

  }
}

export default businessBase
